import { useSyncExternalStore } from 'react'

import { getPrimeMode, subscribePrimeMode } from '@lib/primeMode'

const getServerSnapshot = () => false

export const usePrimeMode = (): boolean => useSyncExternalStore(subscribePrimeMode, getPrimeMode, getServerSnapshot)
